import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sendStatusBC'
})
export class SendStatusBCPipe implements PipeTransform {

  transform(value: number): string {
    if (value === 0) {
      // Returning ' ' because 0 is the default value for enums in AL
      return ' ';
    }


    const name = Status[value];

    if (!name) {
      return 'Undefined Status';
    }

    return name;
  }
}

enum Status {
  Default = 0,
  Sent = 1,
  Received = 2,
  Error = 3
}
